<template>
	<div v-if="site.deleted_at" class="d-none"/>
	<div v-else :id="'card_'+site.id" class="col-xl-3 col-sm-6 col-12 g-4 card-group">
		<div class="card">
			<router-link
				:to="{name:'siteInfo',params:{ clientId: clientId, estateId: estateId, siteId: site.id }}"
				class="card-body inactive link-underline link-underline-opacity-0" type="button"
			>
				<div class="media d-flex">
					<div class="media-body text-left">
						<h4><i class="bi-pin-map me-2"/>{{ site.name }}</h4>
					</div>
				</div>
			</router-link>
			<div class="card-footer" >
				<i class="bi-trash" type="button" @click.prevent="deleteSite(site)"/>
				&nbsp;<i class="bi-pencil" type="button" data-bs-toggle="modal" :data-bs-target="'#edit_'+site.id"/>
				<ModalSiteUpdate :element-id="'edit_'+site.id" :site="site"/>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import ModalSiteUpdate from "@/views/pages/private/dashboard/partials/ModalSiteUpdate.vue";
	import type { Site } from "@/types/site";
	import { useSiteStore } from "@/stores/site";

	const siteStore = useSiteStore();

	const props = defineProps<{
		site: Site
		estateId: string
		clientId: string
	}>();

	async function deleteSite (site: Site) {
		if (confirm("Are you sure you want to to delete this site? All linked surveys will be deleted as well.")) {
			await siteStore.destroy(site);
		}
	}
</script>
